<template>
  <div id="home-page" class="page-wrapper">
    <div id="home-wrapper">
      <!--Mobile Menu-->
      <nav
        id="mobile-navbar"
        class="row no-gutters justify-content-center align-items-center"
      >
        <div class="d-flex mobile-navbar-icon">
          <button
            v-on:click="onMobileIconClicked"
            class="navbar-toggler navbar-toggler-right d-flex justify-content-center align-items-center ml-4"
            type="button"
            id="nav-icon"
            v-bind:class="{ open: isMobileMenuOpen }"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div class="row align-items-center h-100">
          <img
            v-on:click="onLogoClicked()"
            src="../assets/images/winning_form-logo_white.svg"
            class="img-fluid menu-logo"
          />
        </div>
      </nav>
      <div
        class="w-100 justify-content-center align-items-center d-xl-none"
        id="mobile-navbar-dropdown"
        v-bind:class="{ collapse: !isMobileMenuOpen }"
      >
        <div class="mobile-navbar-dropdown-container w-100">
          <div id="mobile-menu">
            <ul
              class="mobile-menu-items row no-gutters list-group align-items-center"
            >
              <li
                v-on:click="onRaceCardsClicked()"
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img src="../assets/images/racecard-icon.svg" />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >RACECARDS</span
                >
              </li>
              <li
                v-on:click="onHowToReadClicked()"
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img src="../assets/images/racecard-icon.svg" />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >HOW TO READ</span
                >
              </li>
              <li
                v-on:click="
                  openLinkInNewTab(
                    'https://blog.hollywoodbets.net/category/horse-racing/winning-form-tips/%7Chttps:/blog.hollywoodbets.net/category/horse-racing/winning-form-tips/',
                  )
                "
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img src="../assets/images/horse-tips-redirect.svg" />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >ANALYSIS & TIPS</span
                >
              </li>
             
              <li
                @click.prevent="mobiledetect()"
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img src="../assets/images/hollywood-icon.svg" />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >HOLLYWOODBETS</span
                >
              </li>
              <li
                @click.prevent="onRaceReplaysClicked()"
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img
                    class="desktop-menu-item-icon"
                    src="../assets/images/BOTChallenge.svg"
                  />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >RACE REPLAYS</span
                >
              </li>
              <li
                v-on:click="
                  openLinkInNewTab('http://syndicate.hollywoodbets.net/')
                "
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img src="../assets/images/results-icon.svg" />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >SYNDICATE</span
                >
              </li>
              <li
                v-on:click="navigateToOldSite()"
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img src="../assets/images/old-site-selector-menu.svg" />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >STANDARD SITE</span
                >
              </li>
              <li
                v-on:click="openLinkInNewTab('https://www.sportingpost.co.za/')"
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img
                    class="desktop-menu-item-icon"
                    src="../assets/images/sporting-post.svg"
                  />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >SPORTINGPOST</span
                >
              </li>
        

              <li
                v-on:click="openLinkInNewTab('https://www.galloptv.co.za/')"
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img
                    class="desktop-menu-item-icon"
                    src="../assets/images/Gallop-TV.svg"
                  />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                >
                  <div>GALLOP TV</div>
                </span>
              </li>
              <li
                v-on:click="openLinkInNewTab('https://www.galloptv.co.za/')"
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img
                    class="desktop-menu-item-icon"
                    src="../assets/images/Gallop-TV.svg"
                  />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                >
                  <div>GALLOP TV</div>
                </span>
              </li>

              <li
                v-on:click="
                  openLinkInNewTab(
                    'https://punterschallenge.hollywoodbets.net/',
                  )
                "
                class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
              >
                <div class="px-0 mobile-menu-item-icon">
                  <img
                    class="desktop-menu-item-icon"
                    src="../assets/images/BOTChallenge.svg"
                  />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                >
                  <div>PUNTERS CHALLENGE</div>
                  <span
                    style="position: relative; left: 10%"
                    class="text align-items-center px-0 justify-content-start text-nowrap free-to-play"
                    >FREE TO PLAY</span
                  >
                </span>
              </li>

              <li
                v-on:click="toggleMetricDown()"
                class="mobile-menu-item nav-item no-gutters row flex-nowrap py-2 align-items-center"
              >
                <div class="col-xl-2 px-0">
                  <img
                    class="desktop-menu-item-icon"
                    src="../assets/images/racecard-icon.svg"
                  />
                </div>
                <span
                  class="text align-items-center px-0 justify-content-start text-nowrap"
                  >TRACKING DATA</span
                >
              </li>

              <li
                v-show="showMetricDD"
                v-on:click="sendToDownloadsScreen()"
                class="nav-item row flex-nowrap py-2 align-items-center ml-2"
              >
                <span
                  class="text col-xl-12 justify-content-center align-items-center px-0 ml-1"
                  >RAW DATA</span
                >
              </li>

              <li
                v-show="showMetricDD"
                v-on:click="toggleReportDD()"
                class="nav-item row flex-nowrap py-2 align-items-center ml-2"
              >
                <div class="col-xl-2 px-0">
                  <img
                    class="desktop-menu-item-icon"
                    src="../assets/images/racecard-icon.svg"
                  />
                </div>
                <span
                  class="text col-xl-12 justify-content-center align-items-center px-0 ml-3"
                  >SECTIONAL REPORTS</span
                >
              </li>

              <li
                v-show="showReportDD"
                v-on:click="sendToKmPerSectReport()"
                class="nav-item row flex-nowrap py-2 align-items-center ml-4"
              >
                <span
                  class="text col-xl-10 justify-content-center align-items-center px-0 ml-1"
                  >Km/H PER SECT</span
                >
              </li>

              <li
                v-show="showReportDD"
                v-on:click="sendToSectionalTimeRank()"
                class="nav-item row flex-nowrap py-2 align-items-center ml-4"
              >
                <span
                  class="text col-xl-10 justify-content-center align-items-center px-0 ml-1"
                  >SECTIONAL INFO</span
                >
              </li>

              <li
                v-show="showReportDD"
                v-on:click="sendToDistanceCoveredSectionalReport()"
                class="nav-item row flex-nowrap align-items-center ml-4"
              >
                <span
                  class="text col-xl-10 justify-content-center align-items-center px-0 ml-1"
                  >DISTANCE COVERED PER SECT</span
                >
              </li>
              <li
                v-show="showReportDD"
                v-on:click="sendToSectionsToFinishReport()"
                class="nav-item row flex-nowrap align-items-center ml-4"
              >
                <span
                  class="text col-xl-10 justify-content-center align-items-center px-0 ml-1"
                  >SECTIONS TO FINISH</span
                >
              </li>
            </ul>
            <div
              class="row d-flex no-gutters justify-content-center align-items-center"
            >
              <div
                class="mobile-social-media-icons row no-gutters justify-content-space-evenly"
              >
                <div
                  v-on:click="
                    openLinkInNewTab('https://www.facebook.com/hollywoodbets/')
                  "
                  class="col-3 px-0 social-item-wrapper"
                >
                  <img src="../assets/images/facebook-icon.svg" />
                </div>
                <div
                  v-on:click="
                    openLinkInNewTab('https://twitter.com/Hollywoodbets')
                  "
                  class="col-3 px-0 social-item-wrapper"
                >
                  <img src="../assets/images/twitter-icon.svg" />
                </div>
                <div
                  v-on:click="
                    openLinkInNewTab('https://www.youtube.com/@GallopTVza')
                  "
                  class="col-3 px-0 social-item-wrapper"
                >
                  <img src="../assets/images/YouTube.svg" />
                </div>
               
              </div>
            </div>
           
            <a
              class="row align-items-center justify-content-center mt-2"
              href="./assets/documents/Customerprivacyfuture.pdf"
              target="_blank"
            >
              <span class="text account-text">Customer Privacy policy</span>
            </a>
            <a
              class="row align-items-center justify-content-center mt-2"
              href="./assets/documents/ACCESS TO INFORMATION MANUAL - HOLLYWOOD GROUP - POPI6.V2.29122021 - Clean.pdf"
              target="_blank"
            >
              <span class="text account-text">PAIA Manual</span>
            </a>
          </div>
         
        </div>
      </div>

      <!--Desktop Menu-->
      <div class="row no-gutters">
        <div
          id="sidebar-container"
          class="sidebar-expanded d-none d-xl-block col-xl-2 align-items-center justify-content-center"
        >
          <div
            class="row d-flex justify-content-center align-items-center py-5"
          >
            <img
              v-on:click="onLogoClicked()"
              src="../assets/images/winning_form-logo_white.svg"
              class="menu-logo col-xl-8"
            />
          </div>
          <ul class="row list-group justify-content-center align-items-center">
            <li
              v-on:click="onLogoClicked()"
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/racecard-icon.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >RACECARDS</span
              >
            </li>
            <li
              v-on:click="onHowToReadClicked()"
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/racecard-icon.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >HOW TO READ</span
              >
            </li>
            <li
              v-on:click="
                openLinkInNewTab(
                  'https://blog.hollywoodbets.net/category/horse-racing/winning-form-tips/%7Chttps:/blog.hollywoodbets.net/category/horse-racing/winning-form-tips/',
                )
              "
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/horse-tips-redirect.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >ANALYSIS & TIPS</span
              >
            </li>
    
            <li
              v-on:click="mobiledetect()"
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/hollywood-icon.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >HOLLYWOODBETS</span
              >
            </li>
            <li
              @click.prevent="onRaceReplaysClicked()"
              class="mobile-menu-item nav-item row no-gutters py-2 flex-nowrap align-items-center"
            >
              <div class="px-0 mobile-menu-item-icon">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/BOTChallenge.svg"
                />
              </div>
              <span
                class="text align-items-center px-0 justify-content-start text-nowrap"
                >RACE REPLAYS</span
              >
            </li>
            <li
              v-on:click="
                openLinkInNewTab('http://syndicate.hollywoodbets.net/')
              "
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/results-icon.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >HOLLYWOOD RACING</span
              >
            </li>
            <li
              v-on:click="navigateToOldSite()"
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/old-site-selector-menu.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >STANDARD SITE</span
              >
            </li>
            <li
              v-on:click="openLinkInNewTab('https://www.sportingpost.co.za/')"
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/sporting-post.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >SPORTINGPOST</span
              >
            </li>
            <li
              v-on:click="openLinkInNewTab('https://www.galloptv.co.za/')"
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/Gallop-TV.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >GALLOP TV
              </span>
            </li>

            <li
              v-on:click="
                openLinkInNewTab('https://punterschallenge.hollywoodbets.net/')
              "
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/BOTChallenge.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >PUNTERS CHALLENGE
                <span
                  style="color: green"
                  class="text col-xl-10 justify-content-center align-items-center px-0 ml-3 free-to-play"
                  >FREE TO PLAY</span
                >
              </span>
            </li>

            <li
              v-on:click="toggleMetricDown()"
              class="nav-item row flex-nowrap py-2 align-items-center"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/racecard-icon.svg"
                />
              </div>
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-3"
                >TRACKING DATA</span
              >
            </li>

            <li
              v-show="showMetricDD"
              v-on:click="sendToDownloadsScreen()"
              class="nav-item row flex-nowrap py-2 align-items-center ml-2"
            >
              <span
                class="text col-xl-12 justify-content-center align-items-center px-0 ml-1"
                >RAW DATA</span
              >
            </li>

            <li
              v-show="showMetricDD"
              v-on:click="toggleReportDD()"
              class="nav-item row flex-nowrap py-2 align-items-center ml-2"
            >
              <div class="col-xl-2 px-0">
                <img
                  class="desktop-menu-item-icon"
                  src="../assets/images/racecard-icon.svg"
                />
              </div>
              <span
                class="text col-xl-12 justify-content-center align-items-center px-0 ml-3"
                >SECTIONAL REPORTS</span
              >
            </li>

            <li
              v-show="showReportDD"
              v-on:click="sendToKmPerSectReport()"
              class="nav-item row flex-nowrap py-2 align-items-center ml-4"
            >
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-1"
                >Km/H PER SECT</span
              >
            </li>

            <li
              v-show="showReportDD"
              v-on:click="sendToSectionalTimeRank()"
              class="nav-item row flex-nowrap py-2 align-items-center ml-4"
            >
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-1"
                >SECTIONAL INFO</span
              >
            </li>

            <li
              v-show="showReportDD"
              v-on:click="sendToDistanceCoveredSectionalReport()"
              class="nav-item row flex-nowrap align-items-center ml-4"
            >
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-1"
                >DISTANCE COVERED PER SECT</span
              >
            </li>
            <li
              v-show="showReportDD"
              v-on:click="sendToSectionsToFinishReport()"
              class="nav-item row flex-nowrap align-items-center ml-4"
            >
              <span
                class="text col-xl-10 justify-content-center align-items-center px-0 ml-1"
                >SECTIONS TO FINISH</span
              >
            </li>
          </ul>
          
          <div
            class="row no-gutters justify-content-center align-items-center mt-4"
          >
            <div
              v-on:click="
                openLinkInNewTab('https://www.facebook.com/WinningForm/')
              "
              class="col-xl-3 px-0 social-item-wrapper"
            >
              <img src="../assets/images/facebook-icon.svg" />
            </div>
            <div
              v-on:click="openLinkInNewTab('https://twitter.com/Hollywoodbets')"
              class="col-xl-3 px-0 social-item-wrapper"
            >
              <img src="../assets/images/twitter-icon.svg" />
            </div>
            <div
              v-on:click="
                openLinkInNewTab('https://www.youtube.com/@GallopTVza')
              "
              class="col-xl-3 px-0 social-item-wrapper"
            >
              <img src="../assets/images/YouTube.svg" />
            </div>

          </div>
          <a
            class="row align-items-center justify-content-center mt-2"
            href="./assets/documents/Customerprivacyfuture.pdf"
            target="_blank"
          >
            <span class="text account-text">Customer Privacy policy</span>
          </a>
          <a
            class="row align-items-center justify-content-center mt-2"
            href="./assets/documents/ACCESS TO INFORMATION MANUAL - HOLLYWOOD GROUP - POPI6.V2.29122021 - Clean.pdf"
            target="_blank"
          >
            <span class="text account-text">PAIA Manual</span>
          </a>
         
        </div>
        <div v-if="showHomeBackground" class="home-background"></div>
        <div class="col-12 col-xl-10 offset-xl-2 body-content">
          <img
            v-if="isLoading"
            class="loading-gif"
            :src="getImage('wf-loading-horse', 'gif')"
          />
          <div
            v-if="isLoading"
            class="col-12 w-100 d-flex justify-content-center align-items-center loading-gif-wrapper"
          ></div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Cookie from "js-cookie";

export default {
  name: "Landing",
  data: function () {
    return {
      isMobileMenuOpen: false,
      raceCourseSubmenuWidth: 0,
      raceCourseSubmenuOpenDesktop: false,
      showHomeBackground: true,
      accountNo: Cookie.get("punterData"),
      showMetricDD: false,
      showReportDD: false,
    };
  },
  computed: mapState(["isLoading", "userAuthToken", "punterData"]),
  methods: {
    sendToSectionsToFinishReport() {
      this.$router.push("/landing/SectionsToFinishFilter");
    },
    sendToDistanceCoveredSectionalReport() {
      this.$router.push("/landing/SectionalDistanceCoveredFilter");
    },
    sendToDistanceCoveredReport() {
      this.$router.push("/landing/PositionSectFilter");
    },
    sendToKmPerSectReport() {
      this.$router.push("/landing/kmhPerSectFilter");
    },
    sendToSectionalTimeRank() {
      this.$router.push("/landing/SectionalTimeRank");
    },
    sendToPositionAndTimeReport() {
      this.$router.push("/landing/SectoionalPositionAndTimeFilter");
    },
    sendToPositionAndMarginBehind() {
      this.$router.push("/landing/PositionAndMarginBehindFilter");
    },
    navigateToOldSite() {
      window.open(`https://legacy.winningform.co.za/`, "_self");
    },
    toggleMetricDown() {
      this.showMetricDD = !this.showMetricDD;
    },
    toggleReportDD() {
      this.showReportDD = !this.showReportDD;
    },
    sendToBehindReports() {
      this.$router.push("/landing/positionBehindFilter");
    },
    sendToSectionalReports() {
      this.$router.push("/landing/sectionalReportFilter");
    },
    sendToDownloadsScreen() {
      this.$router.push("/landing/downloads");
    },
    onFixturesClicked() {
      this.$router.push("/landing/fixtures");
    },
    onRaceCourseClicked() {
      this.transitionRaceCourseSubmenuOut();
      this.transitionMobileMenu();
      this.$router.push("/landing/racecourse");
    },
    onStatisticsClicked() {
      this.$router.push("/landing/statistics");
    },
    onCardChangesClicked() {
      this.$router.push("/landing/cardchanges");
    },
    onRaceCoursesClickedMobile(transitionDirection) {
      transitionDirection === "out"
        ? this.transitionRaceCourseSubmenuIn()
        : this.transitionRaceCourseSubmenuOut();
      this.transitionMobileMenu(transitionDirection);
    },
    openLinkInNewTab(url) {
      window.open(url, "_blank");
    },
    sendMail(mailAddress) {
      document.location.href = `mailto:${mailAddress}`;
    },
    transitionMobileMenu(transitionDirection) {
      const mobileMenuWidth = document
          .querySelector("#mobile-menu")
          .getBoundingClientRect().width,
        closeMenuPosition = -(
          mobileMenuWidth +
          window.innerWidth / 2 -
          mobileMenuWidth / 2
        ),
        openMenuPosition = window.innerWidth / 2 - mobileMenuWidth / 2,
        xPosition =
          transitionDirection === "out" ? closeMenuPosition : openMenuPosition;

      document.querySelector(
        "#mobile-menu",
      ).style.transform = `translate(${xPosition}px, -50%)`;
    },
    transitionRaceCourseSubmenuIn() {
      const submenuWidth = document
          .querySelector("#racecourses-mobile-submenu")
          .getBoundingClientRect().width,
        xPosition = window.innerWidth / 2 + submenuWidth / 2;

      document.querySelector(
        "#racecourses-mobile-submenu",
      ).style.transform = `translate(-${xPosition}px, -50%)`;
    },
    transitionRaceCourseSubmenuOut() {
      const submenuWidth = document
        .querySelector("#racecourses-mobile-submenu")
        .getBoundingClientRect().width;

      document.querySelector(
        "#racecourses-mobile-submenu",
      ).style.transform = `translate(${submenuWidth}px, -50%)`;
    },
    onMobileIconClicked() {
      this.hideShowMobileMenu();
    },
    onRaceCourseSubmenuClickedDesktop() {
      this.raceCourseSubmenuOpenDesktop = !this.raceCourseSubmenuOpenDesktop;
    },
    onRaceCardsClicked() {
      this.$router.push("/landing/home");
    },
    onHowToReadClicked() {
      window.open(
        "https://legacy.winningform.co.za/gif/HowToRead.gif",
        "_blank",
      );
    },
    onRaceReplaysClicked() {
      window.open(
        "https://www.galloptv.co.za/playlists/race-replays",
        "_blank",
      );
    },
    onLogoClicked() {
      if (this.isMobileMenuOpen) this.hideShowMobileMenu();
      this.$router.push("/landing/home");
    },
    hideShowMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      if (this.isMobileMenuOpen) {
        document.body.style.overflow = "hidden";
        this.triggeredOnMobileMenuOpen = true;
      } else {
        document.body.style.overflow = "scroll";
      }
    },
    mobiledetect() {
      let isMobile = false; //initiate as false
      // device detection
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        isMobile = true;
        if (isMobile == true) {
          window.open("https://new.hollywoodbets.net");
        }
      } else {
        window.open("https://new.hollywoodbets.net");
      }
    },
    onPageClicked(evt) {
      const raceCourseMenuItem = document.getElementById(
          "racecourses-menu-item",
        ),
        subMenuItemElement = document.getElementById("racecourses-submenu");
      let targetElement = evt.target;

      do {
        if (
          targetElement === raceCourseMenuItem ||
          targetElement === subMenuItemElement
        )
          return;
        targetElement = targetElement.parentNode;
      } while (targetElement);

      this.raceCourseSubmenuOpenDesktop = false;
    },
    getImage(imagePath, fileType = "svg") {
      return require("../assets/images/" + imagePath + "." + fileType);
    },
    ...mapMutations(["setUserAuthToken"]),
  },
  updated: function () {
    if (this.isMobileMenuOpen && this.triggeredOnMobileMenuOpen) {
      this.$nextTick(() => {
        document.querySelector("#racecourses-mobile-submenu").style.display =
          "block";
        this.raceCourseSubmenuWidth = document
          .querySelector("#racecourses-mobile-submenu")
          .getBoundingClientRect().width;
        document.querySelector(
          "#racecourses-mobile-submenu",
        ).style.right = `-${this.raceCourseSubmenuWidth}px`;
        this.triggeredOnMobileMenuOpen = false;
      });
    }
  },
  watch: {
    $route(to) {
      this.showHomeBackground = to.path.indexOf("home") > -1;
      window.scrollTo(0, 0);
    },
  },
  mounted: function () {
    const menuItems = document.querySelectorAll(".mobile-menu-item");
    menuItems.forEach(
      (menuItem) => (menuItem.onclick = this.hideShowMobileMenu),
    );
    document.addEventListener("click", this.onPageClicked.bind(this));
    document
      .getElementById("mobile-navbar-dropdown")
      .addEventListener("scroll", () => {
        window.scrollTo(0, 0);
      });
    document.querySelector("#mobile-navbar").addEventListener(
      "touchmove",
      function (e) {
        e.preventDefault();
      },
      false,
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dd-hr-data {
  width: 100%;
}
.free-to-play {
  animation: blinkingText 1s infinite;
}

@keyframes blinkingText {
  0% {
    color: green;
    background-color: white;
  }

  10% {
    color: green;
    background-color: white;
  }

  49% {
    color: green;
    background-color: white;
  }

  50% {
    color: white;
    background-color: green;
  }

  99% {
    color: white;
    background-color: green;
  }

  100% {
    color: white;
    background-color: green;
  }
}

.menu-logo {
  height: 80%;
}

.menu-logo:hover {
  cursor: pointer;
}

li {
  border-bottom: 1px solid white;
}

li:nth-child(1) {
  border-top: 1px solid white;
}

.home-search-input {
  background-color: #999da2;
  color: #000000;
  text-align: center;
  font-size: 0.8rem;
  width: 80%;
  height: auto !important;
  border: none;
  border-radius: 3px;
  font-weight: bold;
}

.home-search-input-wrapper {
  line-height: 2rem;
  margin-top: 1.5rem;
}

.mobile-navbar-icon {
  position: fixed;
  left: 0;
}

#mobile-navbar {
  background-color: #000000;
  height: 8vh;
  position: fixed;
  width: 100vw;
  z-index: 5;
}

#mobile-navbar-dropdown {
  position: fixed;
  top: 8vh;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 10;
  height: 92vh;
}

#mobile-menu {
  width: 100%;
  transition: all 500ms ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.mobile-navbar-dropdown-container {
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;
}

#sidebar-container {
  height: 100vh;
  background-color: #000000;
  padding: 0;
  position: fixed;
  z-index: 1;
  overflow-y: auto;
}

.nav-item {
  width: 65%;
  height: 50px;
}

.nav-item:hover {
  cursor: pointer;
  background-color: rgba(27, 26, 33, 0.91);
}

#mobile-navbar {
  display: flex;
}

.mobile-menu-items li {
  padding-left: 0.65rem !important;
  justify-content: flex-start !important;
}

.tnc-logo {
  width: 40px;
  height: 40px;
}

.logout-button {
  color: #ffffff;
  background-color: #000000;
  border: solid 1px #ffffff;
  border-radius: 5px;
  padding: 0.2rem 1.2rem;
  margin-top: 2.2rem;
}

.social-item-wrapper {
  display: grid !important;
  align-items: center !important;
  cursor: pointer;
}

@media (min-width: 576px) {
  .mobile-menu-items li {
    padding-left: 2rem !important;
    justify-content: flex-start !important;
  }
}

@media only screen and (min-device-width: 0px) and (max-device-width: 768px) and (orientation: landscape) {
  .mobile-menu-items li {
    padding-left: 6rem !important;
    justify-content: center !important;
  }
}

@media (min-width: 768px) {
  .mobile-menu-items li {
    padding-left: 10rem !important;
    justify-content: flex-start !important;
  }
}

.home-background {
  background: url("../assets/images/wf-background.jpg") no-repeat center center;
  position: fixed;
  top: 8vh;
  width: 100vw;
  height: 92vh;
}

@media (min-width: 1200px) {
  .home-background {
    top: 0 !important;
    height: 100vh !important;
  }

  #mobile-navbar {
    display: none;
  }

  .nav-item {
    width: 65%;
    height: 4rem;
  }

  .body-content {
    height: 100vh !important;
    margin-top: 0 !important;
  }

  li {
    padding-left: 0.6rem;
  }

  #racecourses-submenu li {
    letter-spacing: 0.1rem;
  }

  .home-search-input-wrapper {
    margin-top: 3.5rem !important;
  }
}

@media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
  #mobile-navbar {
    height: 10vh !important;
  }

  #mobile-navbar-dropdown {
    height: 90% !important;
    top: 10% !important;
  }

  .mobile-navbar-dropdown-container {
    top: 0 !important;
    transform: translateY(0);
    margin-top: 3rem;
  }

  .menu-logo {
    height: 80% !important;
  }

  .nav-item {
    justify-content: center !important;
    padding-left: 0 !important;
  }

  .mobile-social-media-icons {
    width: 30% !important;
  }

  .dropdown-submenu-item {
    font-size: 1.8rem !important;
  }

  .body-content {
    margin-top: 10vh !important;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
  .mobile-menu-items li {
    padding-left: 0rem !important;
    justify-content: center !important;
  }
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
  li span {
    font-size: 1rem;
  }
}

@media (max-height: 720px) {
  #mobile-menu {
    top: 58% !important;
  }
}

@media (max-height: 610px) {
  #mobile-menu {
    top: 62% !important;
  }
}

#nav-icon {
  width: 60px;
  height: 26px;
  position: relative;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;
  padding: 0;
}

#nav-icon span {
  display: block;
  position: absolute;
  height: 3px;
  width: 60%;
  background: #ffffff;
  border-radius: 9px;
  opacity: 1;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
  cursor: pointer;
  display: block;
  position: absolute;
  height: 3px;
  width: 60%;
  background: #ffffff;
  border-radius: 9px;
  opacity: 1;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
  cursor: pointer;
}

#nav-icon span:nth-child(1) {
  top: 0;
}

#nav-icon span:nth-child(2) {
  top: 10px;
}

#nav-icon span:nth-child(3) {
  top: 20px;
}

#nav-icon.open span:nth-child(1) {
  top: 10px;
  -webkit-transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -o-transform: rotate(135deg);
  transform: rotate(135deg);
}

#nav-icon.open span:nth-child(2) {
  opacity: 0;
  left: -60px;
}

#nav-icon.open span:nth-child(3) {
  top: 10px;
  -webkit-transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -o-transform: rotate(-135deg);
  transform: rotate(-135deg);
}

.mobile-social-media-icons {
  width: 45%;
  margin-top: 2.2rem;
}

.body-content {
  height: 92vh;
  margin-top: 8vh;
}

.social-media-icons {
  position: absolute;
  bottom: 0.8rem;
  height: 50px;
}

.mobile-menu-item-icon {
  width: 1.5rem;
  margin-right: 1rem;
}

.desktop-menu-item-icon {
  width: 1.8rem;
}

.dropdown-submenu {
  display: none;
  position: absolute;
  left: 100%;
  background-color: black;
  z-index: 50;
  align-self: flex-start;
  opacity: 0.9;
  padding: 1.3rem 1.6rem 1.3rem 1.6rem;
}

.dropdown-submenu-item {
  border-bottom: none !important;
  border-top: none !important;
  width: 100%;
  font-size: 1.2rem;
  text-align: center;
  padding: 0.3rem 0.2rem 0.3rem 0.2rem;
  font-weight: normal;
}

.mobile-submenu {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -200px;
  z-index: 10;
  transition: all 500ms ease;
}

.racecourse-back-button {
  text-align: center;
  border-top: none !important;
  border-bottom: solid 1px white;
  margin-bottom: 2rem;
  font-size: 1.2rem;
}

.displayBlock {
  display: block;
}
</style>
